// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};
var firebaseConfig = {
  apiKey: "AIzaSyCG5nXc-mJ5dgFtqNuofze_uPfGTw5XdjI",
  authDomain: "haciendamarillo.firebaseapp.com",
  databaseURL: "https://haciendamarillo-default-rtdb.firebaseio.com",
  projectId: "haciendamarillo",
  storageBucket: "haciendamarillo.appspot.com",
  messagingSenderId: "869416639040",
  appId: "1:869416639040:web:270e92d7303259e70cdda5",
  measurementId: "G-B02F5QFKWF"
};